import plugins from './plugins/index.js';

const registerPluginsHelper = Vue => {
  Vue.use(...plugins);
};

export default registerPluginsHelper;
